import { useRef } from 'react';
/**
 * Unlike useEffect, this runs *before* the first render/paint
 * It's roughly equivalent to the old componentWillMount, or a React class constructor
 * If you only need to initialize a piece of state, you can use the lazy useState hook
 * If you need to do more than that prior to the first render, use this.
 */

function useConstructor(constructor) {
    const hasRun = useRef(false);

    if (!hasRun.current) {
        constructor();
        hasRun.current = true;
    }
}
export default useConstructor;
